import deskBookingService from '@/api/deskbooking'
import { DESK_BOOKING } from '../types'
import Vue from 'vue'
import utils from '@/utils/utils'
import errorhandler from '@/utils/errorhandler.js'

const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    log: null,
    currentDate: null,
    locationQueryFilter: null,
    queryFilter: null,
    desksWithBookings: [],
    startTime: null,
    endTime: null,
    location: null,
    deskAttributes: [],
    selectedDesk: {},
    owners: [],
    loadedFirstTime: false,
    selectedDeskBookings: [],
    hasErrorValidation: false,
    canRenderMap: true,
    dates: [],
    userBookedDates: []
  },
  getters: {
    locationQueryFilter: (state) => {
      return state.locationQueryFilter
    },
    queryFilter: (state) => {
      return state.queryFilter
    },
    currentDate: (state) => {
      return state.currentDate
    },
    startTime: (state) => {
      return state.startTime
    },
    endTime: (state) => {
      return state.endTime
    },
    locationId: (state) => {
      return state.location
    },
    deskAttributes: (state) => {
      return state.deskAttributes
    },
    selectedDesk: (state) => {
      return state.selectedDesk
    },
    fullStartDate: (state) => {
      const start = state.dates[0] + ' ' + state.startTime
      const fullStartDate = proto.$moment(start).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      return fullStartDate
    },
    fullEndDate: (state) => {
      const finish = state.dates[0] + ' ' + state.endTime
      const fullEndDate = proto.$moment(finish).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      return fullEndDate
    },
    loadedFirstTime: (state) => {
      return state.loadedFirstTime
    },
    selectedDeskBookings: (state) => {
      return state.selectedDeskBookings
    },
    deskBookings: (state) => {
      return state.selectedDeskBookings.map((db) => {
        return { userEmail: db.user.email, deskId: db.booking.id }
      })
    },
    hasErrorValidation: (state) => {
      return state.hasErrorValidation
    },
    canRenderMap: (state) => {
      return state.canRenderMap
    },
    dates: (state) => {
      return state.dates
    },
    fullDates: (state) => {
      return state.dates.map(date => proto.$moment(date).utc().toISOString())
    },
    fullDatesWithPeriod: (state) => {
      return state.dates.map(date => {
        const formatedDate = proto.$moment(date).format('YYYY-MM-DD')
        const fullStartDate = proto.$moment(formatedDate + ' ' + state.startTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
        const fullEndDate = proto.$moment(formatedDate + ' ' + state.endTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'

        return { start: fullStartDate, finish: fullEndDate }
      })
    }
  },
  mutations: {
    [DESK_BOOKING.LOG_SET](state, log) {
      state.log = log
    },
    [DESK_BOOKING.CURRENT_DATE_SET](state, currentDate) {
      state.currentDate = currentDate
    },
    [DESK_BOOKING.DESK_BOOKING_SET](state, desksWithBookings) {
      state.desksWithBookings = desksWithBookings
    },
    [DESK_BOOKING.SET_LOCATION_QUERY_FILTER](state, locationQueryFilter) {
      state.locationQueryFilter = locationQueryFilter
    },
    [DESK_BOOKING.SET_QUERY_FILTER](state, queryFilter) {
      state.queryFilter = queryFilter
    },
    [DESK_BOOKING.SET_START_TIME](state, start) {
      state.startTime = start
    },
    [DESK_BOOKING.SET_END_TIME](state, end) {
      state.endTime = end
    },
    [DESK_BOOKING.SET_LOCATION](state, location) {
      state.location = location
    },
    [DESK_BOOKING.SET_DESK_ATTRIBUTES](state, deskAttributes) {
      state.deskAttributes = deskAttributes
    },
    [DESK_BOOKING.SET_SELECTED_DESK](state, desk) {
      state.selectedDesk = desk
    },
    [DESK_BOOKING.SELECT_OWNER](state, item) {
      state.owners.splice(0, 1)
      state.owners.push(item)
    },
    [DESK_BOOKING.REMOVE_OWNER](state, index) {
      state.owners.splice(index, 1)
    },
    [DESK_BOOKING.SET_LOADED_FIRST_TIME](state, loadedFirstTime) {
      state.loadedFirstTime = loadedFirstTime
    },
    [DESK_BOOKING.SET_HAS_ERROR_VALIDATION](state, hasErrorValidation) {
      state.hasErrorValidation = hasErrorValidation
    },
    [DESK_BOOKING.ADD_SELECTED_DESK_BOOKING](state, booking) {
      state.selectedDeskBookings.push(booking)
    },
    [DESK_BOOKING.REMOVE_DESK_BOOKING](state, index) {
      state.selectedDeskBookings.splice(index, 1)
    },
    [DESK_BOOKING.SET_SELECTED_DESK_BOOKING](state, deskBookings) {
      state.selectedDeskBookings = deskBookings
    },
    [DESK_BOOKING.SET_CAN_RENDER_MAP](state, canRenderMap) {
      state.canRenderMap = canRenderMap
    },
    [DESK_BOOKING.CHANGE_USER_DESK_BOOKING](state, { key, user }) {
      state.selectedDeskBookings[key].user = user
    },
    [DESK_BOOKING.SET_DATES](state, dates) {
      state.dates = dates
    },
    [DESK_BOOKING.SET_USER_BOOKED_DATES](state, userBookedDates) {
      state.userBookedDates = userBookedDates
    }
  },
  actions: {
    getAllDesksWithTheirBookings({ commit, state }) {
      return new Promise((resolve, reject) => {
        const date = proto.$moment(state.currentDate).utc().format()
        deskBookingService.getAllDesksWithTheirBookings(state.queryFilter, state.locationQueryFilter, date).then((response) => {
          commit(DESK_BOOKING.DESK_BOOKING_SET, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    setCurrentDate({ commit }, currentDate) {
      commit(DESK_BOOKING.CURRENT_DATE_SET, currentDate)
    },
    setLocationQueryFilter({ commit }, locationQueryFilter) {
      commit(DESK_BOOKING.SET_LOCATION_QUERY_FILTER, locationQueryFilter)
    },
    setQueryFilter({ commit }, queryFilter) {
      commit(DESK_BOOKING.SET_QUERY_FILTER, queryFilter)
    },
    setStartTime({ commit }, start) {
      commit(DESK_BOOKING.SET_START_TIME, start)
    },
    setEndTime({ commit }, end) {
      commit(DESK_BOOKING.SET_END_TIME, end)
    },
    setLocation({ commit }, location) {
      commit(DESK_BOOKING.SET_LOCATION, location)
    },
    setDeskAttributes({ commit }, attributes) {
      commit(DESK_BOOKING.SET_DESK_ATTRIBUTES, attributes)
    },
    setSelectedDesk({ commit }, desk) {
      commit(DESK_BOOKING.SET_SELECTED_DESK, desk)
    },
    setLoadedFirstTime({ commit }, loadedFirstTime) {
      commit(DESK_BOOKING.SET_LOADED_FIRST_TIME, loadedFirstTime)
    },
    setHasErrorValidation({ commit }, hasErrorValidation) {
      commit(DESK_BOOKING.SET_HAS_ERROR_VALIDATION, hasErrorValidation)
    },
    selectOwner({ commit, }, item) {
      let owner = item.email ? { email: item.email, name: item.name } : { email: item }
      commit(DESK_BOOKING.SELECT_OWNER, owner)
    },
    removeOwner({ commit }, index) {
      commit(DESK_BOOKING.REMOVE_OWNER, index)
    },
    clearDesksWithBookings({ commit }) {
      commit(DESK_BOOKING.DESK_BOOKING_SET, [])
    },
    getAuditLogsList({ commit, state }, deskId) {
      const date = proto.$moment(state.currentDate).utc().format()
      return new Promise((resolve, reject) => {
        deskBookingService.getAuditLogs(deskId, date).then((response) => {
          commit(DESK_BOOKING.LOG_SET, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    createNewBooking({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const siteId = payload.params.siteId
        const locationId = payload.params.locationId
        const deskId = payload.params.deskId
        const filterManageBookingSite = payload.filterManageBookingParams.filterManageBookingSite
        const filterManageBookingLocal = payload.filterManageBookingParams.filterManageBookingLocal
        deskBookingService.createNewBooking(locationId, deskId, payload.body).then((response) => {
          if (siteId === filterManageBookingSite && locationId === filterManageBookingLocal) {
            dispatch('DeskBooking/getAllDesksWithTheirBookings', null, { root: true })
          }
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    async saveBookingOfAnUser({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true });
      const { locationId, bookings} = payload;
      const body = { bookings };

      try {
        return await deskBookingService.createRecurrencyBooking(locationId, body);
      } catch (error) {
        let errorData = error?.response?.data?.error?.errors[0]?.data
        let messageValues = []

        if (errorData) {
          messageValues = [
            errorData.userReachedBookingLimitError.limitAmountOfBookings,
            errorData.userReachedBookingLimitError.bookingLimitPeriodInDays
          ]
        }

        errorhandler.handleError(error, messageValues);
        throw error;
      } finally {
        dispatch('Global/hideLoading', null, { root: true });
      }
    },
    markBookingAsCheckedIn({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        deskBookingService.markBookingAsCheckedIn(payload.locationId, payload.deskId, payload.bookingId).then((response) => {
          resolve(response)
        }).catch((error) => {
          dispatch('checkInError', error)
          reject(error)
        })
      })
    },
    checkInError({ dispatch }, error) {
      if (error.response && (error.response.status === 404 || error.response.status === 403 || error.response.status === 409)) {
        switch (error.response.data.error.errors[0].reason) {
          case 'bookingNotFound':
            dispatch('Global/showMessage', 'bookingNotFound', { root: true })
            break
          case 'deskNotFound':
            dispatch('Global/showMessage', 'deskNotFoundCheckIn', { root: true })
            break
          case 'inactiveDesk':
            dispatch('Global/showMessage', 'inactiveDeskCheckIn', { root: true })
            break
          case 'userNotFound':
            dispatch('Global/showMessage', 'userNotFoundCheckIn', { root: true })
            break
          case 'bookingNotInBookedState':
            dispatch('Global/showMessage', 'bookingNotInBookedStateCheckIn', { root: true })
            break
          case 'checkinTimeOutsideBookingRequest':
            dispatch('Global/showMessage', 'checkinTimeOutsideBookingRequestCheckIn', { root: true })
            break
          case 'inactiveLocation':
            dispatch('Global/showMessage', 'inactiveLocationCheckIn', { root: true })
            break
          case 'bookingNotBelongToThisUser':
            dispatch('Global/showMessage', 'bookingNotBelongToThisUserCheckIn', { root: true })
            break
          default:
            break
        }
      }
    },
    // eslint-disable-next-line no-empty-pattern
    markBookingAsCheckedOut({ }, payload) {
      return new Promise((resolve, reject) => {
        deskBookingService.markBookingAsCheckedOut(payload.locationId, payload.deskId, payload.bookingId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    markBookingAsCheckedOutOfAnUser({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        deskBookingService.markBookingAsCheckedOutOfAnUser(payload.location.id, payload.desk.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, { root: true })
        )
      })
    },
    async pairAndMarkBookingAsCheckedInOfAnUser({ dispatch }, payload) {
      try {
        if (payload.region === null) {
          dispatch('Global/showMessage', 'noRegionError', { root: true })
          return Promise.reject()
        }
        dispatch('Global/setPairDialogHelper', true, { root: true })
        let dataPrefixWithoutTxPower = utils.createDataPrefixWithoutTxPower(payload.region.uuid, payload.region.major, payload.region.minor)
        let filters = [
          {
            manufacturerData: [{
              companyIdentifier: 0x0C01,
              dataPrefix: utils.concatTxPowerPsensor(dataPrefixWithoutTxPower)
            }]
          },
          {
            manufacturerData: [{
              companyIdentifier: 0x0C01,
              dataPrefix: utils.concatTxPowerMonitoring(dataPrefixWithoutTxPower)
            }]
          }]
        let options = {
          filters: filters,
        };
        await navigator.bluetooth.requestDevice(options)
        return dispatch('markBookingAsCheckedInOfAnUser', payload)
      }
      catch (error) {
        dispatch('Global/showMessage', 'pairingError', { root: true })
        return Promise.reject()
      }
      finally {
        dispatch('Global/setPairDialogHelper', false, { root: true })
      }
    },
    markBookingAsCheckedInOfAnUser({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        deskBookingService.markBookingAsCheckedInOfAnUser(payload.location.id, payload.desk.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          dispatch('checkInError', error)
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, { root: true })
        )
      })
    },
    // eslint-disable-next-line no-empty-pattern
    deleteBooking: function ({ }, payload) {
      return new Promise((resolve, reject) => {
        deskBookingService.deleteBooking(payload.locationId, payload.deskId, payload.bookingId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deleteBookingOfAnUser: function ({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        deskBookingService.deleteBookingOfAnUser(payload.location.id, payload.desk.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, { root: true })
        )
      })
    },
    clearFilters: function ({ commit }) {
      commit(DESK_BOOKING.SET_LOCATION_QUERY_FILTER, null)
      commit(DESK_BOOKING.SET_QUERY_FILTER, null)
      commit(DESK_BOOKING.DESK_BOOKING_SET, [])
    },
    upsertDeskBooking({ commit, dispatch, getters }, item) {
      const deskBooking = item.data
      if (getters.selectedDeskBookings.some((d) => d.user.email === deskBooking.user.email)) {
        dispatch('Global/showMessage', 'userAlreadySelected', { root: true })
        return
      }

      if (item.key >= 0) {
        commit(DESK_BOOKING.CHANGE_USER_DESK_BOOKING, { key: item.key, user: deskBooking.user })
      } else {
        commit(DESK_BOOKING.ADD_SELECTED_DESK_BOOKING, deskBooking)
      }
      commit(DESK_BOOKING.SET_CAN_RENDER_MAP, false)
    },
    removeDeskBooking({ commit, getters }, index) {
      commit(DESK_BOOKING.REMOVE_DESK_BOOKING, index)
      if (getters.selectedDeskBookings.length === 0) {
        commit(DESK_BOOKING.SET_CAN_RENDER_MAP, true)
      }
    },
    clearSelectedDeskBooking({ commit }) {
      commit(DESK_BOOKING.SET_SELECTED_DESK_BOOKING, [])
      commit(DESK_BOOKING.SET_CAN_RENDER_MAP, true)
    },
    saveBookingOfAnInvite({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true })
      const { inviteId, start, finish, userEmail, deskId } = payload
      const body = { start, finish, userEmail, deskId }
      return new Promise((resolve, reject) => {
        deskBookingService.createBookingOfAnInvite(inviteId, body).then((response) => {
          resolve(response)
        }).catch((error) => {
          errorhandler.handleError(error)
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    async getUserBookedDates({ dispatch, commit }, payload) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        const response = await deskBookingService.getUserBookedDates(payload.start, payload.end)
        commit(DESK_BOOKING.SET_USER_BOOKED_DATES, response.data)
      } catch (error) {
        errorhandler.handleError(error);
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    setDates({ commit }, dates) {
      commit(DESK_BOOKING.SET_DATES, dates)
    }
  }
}
